export const META_PIXEL_ID = '2314886982646161'

type FbqFn = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue?: unknown[]
  push?: unknown
  loaded?: boolean
  version?: string
}

declare global {
  interface Window {
    fbq?: FbqFn
    _fbq?: FbqFn
  }
}

/** Injects the Meta Pixel base code once and initializes it. */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || window.fbq) return

  const n: FbqFn = function (...args: unknown[]) {
    if (n.callMethod) {
      n.callMethod.apply(n, args)
    } else {
      n.queue?.push(args)
    }
  } as FbqFn

  window.fbq = n
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  n('init', META_PIXEL_ID)
}

export function trackPageView(): void {
  window.fbq?.('track', 'PageView')
}

export function trackAddToCart(payload: {
  content_name: string
  content_ids: string[]
  value: number
  currency?: string
}): void {
  window.fbq?.('track', 'AddToCart', {
    content_type: 'product',
    currency: 'USD',
    ...payload,
  })
}
